import { useContext } from 'react'
import SubsidiesContext from './SubsidiesContext'

const useSubsidiesData = () => useContext(SubsidiesContext)

export default useSubsidiesData
